// Module
var code = "<a ng-href={{$ctrl.linkedinAccount.public_url}} target=_blank ng-click=$event.stopPropagation()> <i class=\"fab fa-linkedin\"></i> </a> ";
// Exports
module.exports = code;